"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _makeUserSettingsDependencyDeref = _interopRequireDefault(require("crm_data/settings/makeUserSettingsDependencyDeref"));

var _default = function _default() {
  return {
    stores: [_UserSettingsStore.default],
    deref: _makeUserSettingsDependencyDeref.default.apply(void 0, arguments)
  };
};

exports.default = _default;
module.exports = exports.default;